import { ObjectView } from "./object";
import recipeModule from "@/store/recipe.module"
import { TextView } from "./text";
import { Recipe } from "../recipe";
import { RecipeRow } from "./properties/range/reciperow";
import Konva from "konva";
import { Value } from "../value";


export class RecipeTable extends ObjectView{
    recipename:string;
    title:string;
    fontsize:number;
    namecolumnwidth:number;
    othercolumnwidth:number;
    usetitle:boolean;
    recipe:Recipe;
    rows:RecipeRow[]

    x:number;
    y:number;

    beginrow=0;

    public drawObject():void{
        super.initObject()
        this.x = 0
        this.y=0
        if (this.usetitle){
            const title = new TextView()
            title.width = this.width
            title.height = this.height/10
            title.text = this.title
            title.fontsize = this.fontsize
            title.posx = 0
            title.posy = 0
            title.textplacement = 0
            title.textcolor = '0x000000FF'
            title.useborder = false
            title.bordercolor = null
            title.linewidth = 0
            title.fill = false
            title.fillcolor = '0xFFFFFF00'
            title.underline = false
            title.initLayer(this.layer)
            title.drawObject()
            this.node.add(title.rotatednode)
            this.y+=this.height/10;
        }
      
            this.drawTitle(this.namecolumnwidth, 'Name')
            this.x+=this.namecolumnwidth
        
        this.recipe.ingredients.forEach((ingredient)=>{
                this.drawTitle(this.othercolumnwidth, ingredient.ingredientname+(ingredient.unit.length==0?"":"("+ingredient.unit+")"))
                this.x+=this.othercolumnwidth
        })
        this.y+=this.fontsize+5
        this.x=0;
        let numrow = 0;
        this.rows.forEach((reciperow)=>{
            numrow++;
            if (numrow<this.beginrow)
                return;
            this.drawRow(reciperow)
        })
 
        this.node.on('wheel', (e)=> {
            this.beginrow+=e.evt.deltaY/(3*this.fontsize+3)
            if(this.beginrow<0)
                this.beginrow=0
            if (this.beginrow>this.rows.length-2)
                this.beginrow=this.rows.length-2
            //console.log("beginrow="+this.beginrow)
        
            setTimeout(()=>{
                this.drawObject()
            }, 200);
        })
    }

    public setField(field:string, value:Value){
        super.setField(field, value)
        switch(field){
            case "title": {this[field] = value.value;this.rotatednode=null;break;}
            case "fontsize":
            case "namecolumnwidth":
            case "othercolumnwidth": {this[field] = Math.round(value.value);this.rotatednode=null;break;}
            case "usetitle": {
                if(value.value == 0 || value.value == '0' || value.value==false || value.value.toLowerCase()=='false'){
                    this[field]= false
                    this.rotatednode=null;
                }else if(value.value == 1 || value.value == '1' || value.value==true || value.value.toLowerCase()=='true'){
                    this[field]= true 
                    this.rotatednode=null;
                } 
                break;}
            //ase "rownumber": {this[field] = Math.round(value.value);this.rotatednode=null;break;}
        }
        //this.drawObject();
    }

    public getField(field:string):Value{
        const value = super.getField(field)
        switch(field){
            case "title": {value.datatype=7; value.value = this[field];break}
            case "fontsize":
            case "namecolumnwidth":
            case "othercolumnwidth": {value.datatype=3; value.value = this[field];break}

            case "usetitle": {value.datatype=0; value.value = (this[field]);break}
            //case "rownumber":  {value.datatype=3; value.value = this[field];break}
           
        }
        return value;
    }
    
    private drawRow(reciperow:RecipeRow){
        if (this.y+this.fontsize+5>this.height)
             return;
        this.x=0
        const row = new Konva.Group()
        const color ="0x000000FF"
        const bgcolor = "0xFFFFFFFF"
        this.drawRowCell(row,this.namecolumnwidth,reciperow._name,color,bgcolor)
      //  console.log(reciperow)
        this.x+=this.namecolumnwidth
        reciperow.tagnames = new Map()
        reciperow.columnnames = new Map()
        this.recipe.ingredients.forEach((ing)=>{
                reciperow.tagnames.set(ing.dbname, ing.path)
                reciperow.columnnames.set(ing.dbname, ing.ingredientname)
                this.drawRowCell(row,this.othercolumnwidth,reciperow.ingredients[ing.dbname],color,bgcolor)
                this.x+=this.othercolumnwidth
        })
        row.setAttr("row", reciperow)
        row.on('mousedown touchstart',()=>{  
            //console.log(row.getAttr("row"))
            recipeModule.setRecipeRow(row.getAttr("row"))
            recipeModule.setRecipeRowEnabled(true)
      });
          this.node.add(row)
        this.y+=this.fontsize+5
    }
    private drawRowCell(node:Konva.Group,width:number, text:string, textcolor:string, bgcolor:string){
        this.drawCell(node, width, text, textcolor,bgcolor)
    }
    private drawTitle(width:number, text:string){
        this.drawCell(this.node,width,text,'0x000000FF', '0xBBBBBBFF')
    }
    private drawCell(node:Konva.Group, width:number, text:string, textcolor:string, fillcolor:string){
        if (this.x>this.width) return;
        const cell = new TextView()
        cell.width = (this.x+width)>this.width?this.width-this.x:width
        cell.height = this.fontsize+5
        cell.text = text
        cell.fontsize = this.fontsize
        cell.posx = this.x;
        cell.posy = this.y
        cell.textplacement = 1;
        cell.textcolor = textcolor
        cell.useborder = true
        cell.bordercolor = '0x000000FF'
        cell.linewidth = 1
        cell.fill = true
        cell.fillcolor = fillcolor
        cell.underline = false
        cell.initLayer(this.layer)
        cell.drawObject()
        node.add(cell.rotatednode)
    }
}